import * as actionTypes from '../actions/actionTypes';

const initialState = { search: [], activeSearchPage: 1 }

const searchReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.FETCH_SEARCH_LIST: {
            return {
                ...state,
                activeSearchPage: 1,
                search: action.search,
            }
        }
        case actionTypes.CREATE_SEARCH: {
            return {
                ...state,
                activeSearchPage: 1,
                search: action.search
            }
        }
        case actionTypes.CLEAR_SEARCH: {
            return initialState;
        }
        case actionTypes.ACTIVE_PAGE: {
            return {
                ...state,
                activeSearchPage: action.page
            }
        }
        default: {
            return state;
        }
    }
}

export default searchReducer;